import React, { ReactElement } from "react";
import Text from "../Text/Text";
import LinkButton from "../LinkButton/LinkButton";
import styles from "./InputContainer.module.css";

interface InputContainerProps {
  withExampleLink?: boolean;
  forLabel: string;
  required: boolean;
  onExampleClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
  exampleText?: string;
  errorText?: string;
  labelText?: string;
  exampleLinkId?: string;
  children: React.ReactNode;
}

const InputContainer: React.FC<InputContainerProps> = ({
  withExampleLink = false,
  required = false,
  onExampleClick,
  exampleText,
  errorText,
  labelText,
  children,
  forLabel,
  exampleLinkId,
  ...rest
}): ReactElement => {
  return (
    <div aria-label={labelText} className={styles.InputContainer} {...rest}>
      {labelText && (
        <div className={withExampleLink ? styles.label_link_wrapper : ""}>
          <label htmlFor={forLabel}>
            <Text wrapper="span" type="body" color="#000000">
              {labelText}
            </Text>
            {required && <span className={styles.required_input}> *</span>}
          </label>
          {withExampleLink && (
            <LinkButton
              name={exampleLinkId}
              onClick={onExampleClick}
              id={exampleLinkId}
              style={{
                fontWeight: "normal",
                fontSize: "1rem",
                lineHeight: "19px",
                color: "#000000",
              }}
            >
              Give me an example
            </LinkButton>
          )}
        </div>
      )}
      {exampleText && (
        <Text wrapper="span" type="body" size="16px" style={{ marginBottom: "0.25rem" }}>
          {exampleText}
        </Text>
      )}
      {children}
      {errorText && (
        <Text wrapper="span" type="error" style={{ marginTop: "0.3rem" }}>
          {errorText}
        </Text>
      )}
    </div>
  );
};

export default InputContainer;
